import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import logo from '/logo.svg';

import Button from 'components/Button';

const LoginAll = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full items-center justify-center max-h-screen">
      <div className="flex flex-col border py-[60px] px-[40px] rounded-2xl border-[#CBCBCB] bg-[#fff] w-[480px] md:w-[358px] md:py-[40px] md:mb-[100px]">
        <div className="justify-center items-center flex">
          <img src={logo} alt="logo" />
        </div>
        <div className="text-3xl font-bold my-[40px] justify-center items-center flex md:text-2xl">
          {t('welcomeToEvs')}
        </div>
        <div className="flex justify-center mb-[16px]">
          <Button onClick={() => navigate('/auth/login-omya')}>
            {t('continueWithSSO')}
          </Button>
        </div>
        <div className="flex items-center justify-between">
          <div className="h-px bg-[#E2E2E2] w-1/3 mx-3" />
          <div className="text-base text-[#757575] justify-center items-center flex">
            {t('or')}
          </div>
          <div className="h-px bg-[#E2E2E2] w-1/3 mx-3" />
        </div>
        <div className="flex justify-center mt-[16px]">
          <Button
            onClick={() => navigate('/auth/login-distributor')}
            btnType="secondary"
          >
            {t('signInWithCredentials')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginAll;
